var map = {
	"./accessories01.png": "zkt4",
	"./accessories02.png": "TDCH",
	"./accessories03.png": "YKRI",
	"./accessories04.png": "T8Pl",
	"./accessories05.png": "0QgV",
	"./accessories06.png": "fot2",
	"./arrow-accent.png": "RWki",
	"./arrow.png": "nMSj",
	"./avatar.png": "zn0s",
	"./bottoms01.png": "yeGj",
	"./bottoms02.png": "3mIG",
	"./footwear01.png": "4uBL",
	"./footwear02.png": "7etH",
	"./footwear03.png": "objz",
	"./innerwear01.png": "JKWT",
	"./innerwear02.png": "M2M0",
	"./innerwear03.png": "XsKJ",
	"./midwear01.png": "PR9z",
	"./midwear02.png": "dEdo",
	"./midwear03.png": "oI83",
	"./outerwear01.png": "xn3F",
	"./outerwear02.png": "dVss"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9YvT";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/anatomy ^\.\/.*\.png$
// module id = 9YvT
// module chunks = 0